import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import ArticleStyles from './article-styles'
import article from '../blog/article'
import Dotdotdot from 'react-dotdotdot'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import ApiContext from '../../utils/api-context'
import Image from 'next/image'

const ArticleCard = (props) => {
  const classes = ArticleStyles({})
  const moment = require('moment')
  const { i18n } = useTranslation()
  const router = useRouter()
  const { apiUrl, cdnUrl } = useContext(ApiContext)

  const createdAt = moment(props.article.updated_at).format('DD MMM YYYY')
  return (
    <div
      className={`article-card ${
        props.alt ? 'alt-article' : 'standard-article'
      } ${
        props.hasOwnProperty('className') && props.className !== ''
          ? props.className
          : ''
      }`}
    >
      <div className={classes.cardInner}>
        <div className="flex flex-col h-full">
          <div
            className={props.modulus ? classes.cardImageAlt : classes.cardImage}
          >
            <Image
              src={
                props.article.featuredImage.formats &&
                props.article.featuredImage.formats.medium
                  ? props.article.featuredImage.formats.medium.url
                  : props.article.featuredImage.url
              }
              alt=""
              layout={'responsive'}
              width={443}
              height={276}
              // height={props.modulus ? 552 : 276}
              placeholder={'blur'}
              blurDataURL={
                props.article.featuredImage.formats &&
                props.article.featuredImage.formats.small
                  ? props.article.featuredImage.formats.small.url
                  : props.article.featuredImage.url
              }
            />
            {/*<img src={`${}`} alt="" />*/}
          </div>
          <div
            className={`flex-grow ${
              props.alt ? classes.cardContentAlt : classes.cardContent
            }`}
          >
            <div className="flex-grow border-b border-b-grey-300 pb-4">
              <p>{createdAt}</p>
              <h2>{props.article[`title`]}</h2>
              <p className="line-clamp-3">{props.article.standfirst}</p>
              {props.article.categories && props.article.categories.length > 0 && (
                <Link
                  href={`/blog/${props.article.categories[0].slug}/${props.article.slug}`}
                  locale={i18n.language}
                >
                  Read More
                </Link>
              )}
            </div>
            {props.article.tags && props.article.tags.length > 0 && (
              <div className={classes.tags}>
                {props.article.tags.map((tag, i) => {
                  return (
                    <React.Fragment key={i}>
                      <span>{tag[`name`]}</span>{' '}
                    </React.Fragment>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
ArticleCard.propTypes = {
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  alt: PropTypes.bool,
  modulus: PropTypes.bool,
}
export default ArticleCard
